<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <!-- Loader -->
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading) {
<div>
    <h4>Select Banker:</h4>
    <form name="setbanker" novalidate>
      @for (entity of bankerArray; track trackByIndex(i, entity); let i = $index) {
<div class="banker-option">
        <input type="radio" 
               [name]="'gofSelection'"
               [value]="entity"
               [checked]="selectedBanker === entity"
               (change)="onBankerSelect(entity)">
        <span class="banker-label">
          {{ entity.LEID }} &nbsp; {{ entity.DIVISION }} &nbsp; {{ entity.MAIN_BUSINESS }}
        </span>
      </div>
}
    </form>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
